import { render, staticRenderFns } from "./Carrier.vue?vue&type=template&id=13c2c848&scoped=true"
import script from "./Carrier.vue?vue&type=script&lang=js"
export * from "./Carrier.vue?vue&type=script&lang=js"
import style0 from "./Carrier.vue?vue&type=style&index=0&id=13c2c848&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2c848",
  null
  
)

export default component.exports